import { EssayExecutionAirResultParticles, EssayExecutionAirZeroResultParticles, EssayExecutionResultAir } from './essayExecutionResultAir';

import { Criteria } from './criteria';
import { EssayExecutionAirInternalEquipment } from './essayExecutionAirInternalEquipment';
import { Field } from './field';
import { EssayFile } from './essayFile';

export class EssayProtocolAir {
    id: number;

    idEssayType: number;
    idEquipment: number;
    idRoom: number;
    idCompressedGas: number;
    idUnit: number;
    notes: string;
    equipmentNA: boolean;
    according: boolean;
    idOffline: string;

    regUser: string;
    modUser: string;

    regFc: Date;
    modFc: Date;

    fromProtocol = false;
    reasonChange: string;

    criterias: Criteria[] = [];

    essayValues: Field[] = [];

    values: EssayExecutionResultAir[] = [];
    equipments: EssayExecutionAirInternalEquipment[] = [];

    valuesParticles: EssayExecutionAirResultParticles[] = [];

    valuesZeroParticles: EssayExecutionAirZeroResultParticles[] = [];

    idVideo: number;
    idCertificate: number;

    idExcel: number;
    reasonChangeExcel: string;

    active = true;
    reasonActive: string;

    showDiffInDeviations = true;
    showDiffInObservations: boolean;

    forceAccording = false;

    essayFile: EssayFile;
    position: number;

    videos: EssayExecutionAirFiles[] = [];

    zeroCount: boolean;
    idExcelZeroCount: number;

    purpose: string;
    methodology: string;
    purposeTranslated: string;
    methodologyTranslated: string;
}

export class EssayExecutionAirFiles {
    id: number;
    idEssay: number;
    idVideo: number;
    regUser: string;
    modUser: string;
    regFc: Date;
    modFc: Date;
    name: string;
    position: number;
}

export class MovePositionEssay {
    idTestType: number;
    position: number;
}